/**
 * Utility functions for handling impersonation parameters in API calls
 */

/**
 * Appends impersonation parameters to a query string if they exist in sessionStorage
 * @param existingParams - Existing query string parameters
 * @returns Query string with impersonation parameters appended
 */
export const appendImpersonationParams = (existingParams: string = ''): string => {
  const impersonating = sessionStorage.getItem("impersonate");
  const impersonatingDealership = sessionStorage.getItem("impersonate_dealership");
  
  let params = existingParams;
  
  // Add impersonating role parameter
  if (impersonating) {
    const separator = params && !params.startsWith('?') && !params.startsWith('&') ? '&' : '';
    const prefix = params === '' ? '' : separator;
    params += `${prefix}impersonating=${encodeURIComponent(impersonating)}`;
  }
  
  // Add dealer impersonating parameter
  if (impersonatingDealership) {
    const separator = params === '' ? '' : '&';
    params += `${separator}dealer_impersonating=${encodeURIComponent(impersonatingDealership)}`;
  }
  
  return params;
};

/**
 * Creates a complete query string with impersonation parameters
 * @param baseParams - Base parameters object or string
 * @returns Complete query string with impersonation parameters
 */
export const buildQueryWithImpersonation = (baseParams: string | Record<string, any> = ''): string => {
  let queryString = '';
  
  // Convert object params to query string if needed
  if (typeof baseParams === 'object') {
    const searchParams = new URLSearchParams();
    Object.entries(baseParams).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== '') {
        searchParams.append(key, String(value));
      }
    });
    queryString = searchParams.toString();
  } else {
    queryString = baseParams;
  }
  
  return appendImpersonationParams(queryString);
};
